export enum UserSelectionType {
  Single,
  Multiple,
}
